import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { getApiCall, postApiCall } from "../../../service/httpCall"; // Adjust the path if necessary
import Loader from "../../../components/partials/components/loader";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { BACKEND_API_BASE_URL, USER_ROLES, MODULE_ACL } from "../../../utilities/constant";
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting"
import "./index.css";
import { Dialog } from "primereact/dialog";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../../../assets/custom/css/custom.css";
import { DeleteIcon } from "../../../components/setting/elements";
import RenderDeleteModal from "../../../components/partials/components/delete-modal";
import { Checkbox } from 'primereact/checkbox';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import exportData from '../../../utilities/export';


const ViewVoiceFiles = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [selectedData, setSelectedPrompt] = useState([]);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [deletePromptId, setDeletePromptId] = useState(undefined);
  const [enableDeleteModal, setEnableDeleteModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [userRole, setUserRole] = useState(null);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  const fetchPrompts = () => {
    setLoading(true);
    let url = '';

    if (isSuperAdmin) {
      url = `${BACKEND_API_BASE_URL}/v2/prompt?prompt_status=1`;
    } else if (userId) {
      url = `${BACKEND_API_BASE_URL}/v2/prompt/?user_id=${userId}`;
    }

    if (url) {
      getApiCall(url)
        .then(onPromptsSuccess)
        .catch(onError)
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchValue) {
      setPrompts(
        prompts.filter((data) => data.prompt_name.toLowerCase().includes(searchValue.trim().toLowerCase()))
      );
    }
    else {
      setPrompts(originalDataList);
    }
  }, [searchValue, prompts]);

  useEffect(() => {
    fetchPrompts();
  }, [isSuperAdmin, userId]);

  const handleCheckboxToggle = (promptId) => {
    const isSelected = selectedData.includes(promptId);
    setSelectedPrompt(isSelected
      ? selectedData.filter(id => id !== promptId)
      : [...selectedData, promptId]);
  };

  const handleMultiDelete = () => {
    setIsMultiDelete(true);
    setEnableDeleteModal(true);
  };

  function handlePromptDelete(id) {
    checkAuth(setToastProps, setShowToast)
    setIsMultiDelete(false);
    setEnableDeleteModal(true);
    setDeletePromptId(id);
  }


  const handleSelectAll = () => {
    if (selectedData.length === prompts.length) {
      setSelectedPrompt([]);
    } else {
      const allPromptsIds = prompts.map(prompt => prompt.id);
      setSelectedPrompt(allPromptsIds);
    }
  };

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
  
    useEffect(() => {
      const user = getUser();
        if (user) {
          if (user?.acl_settings) {    
            setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
          }
        }
    }, []);


  useEffect(() => {
    if (confirmDelete) {
      postApiCall(`${BACKEND_API_BASE_URL}/v2/prompt/delete`, { promptIds: isMultiDelete ? selectedData : [deletePromptId] })
        .then(onDeleteSuccess)
        .catch(onDeleteFail)
    }
  }, [confirmDelete]);

  function onDeleteSuccess(resp) {
    toast.success(resp)
    let updatedList;
    if (isMultiDelete) {
      updatedList = prompts.filter(val => !selectedData.includes(val.id)).map((val, key) => {
        val['key'] = key + 1;
        return val;
      });
      setSelectedPrompt([]);
    } else {
      updatedList = prompts
        .filter((val) => val.id != deletePromptId)
        .map((val, key) => {
          val["key"] = key + 1;
          return val;
        });
    }
    setPrompts(updatedList);
    setEnableDeleteModal(false);
    setDeletePromptId(undefined);
    setConfirmDelete(false);
    fetchPrompts();
  }


 
const handleRefresh = () => {
  setLoading(true); 
  setSearchValue("");
  fetchPrompts(); 
};


  function onDeleteFail(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      toast.warning(`Unable to delete prompt: ${err}`)
    }
    setConfirmDelete(false);

  }


  const rowClassName = (data) => {
    return {
      'highlighted-row': selectedData.includes(data.id)
    };
  }


  useEffect(() => {
  if (searchValue) {
    const filtered = originalDataList.filter((data) =>
      data.prompt_name.toLowerCase().includes(searchValue.trim().toLowerCase())
    );
    setPrompts(filtered);
  } else {
    setPrompts(originalDataList);
  }
}, [searchValue, originalDataList]); // dependency ko originalDataList rakhein



  useEffect(() => {
    const user = getUser();
      if (user) {
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
        if (user.role == USER_ROLES.SUPERADMIN) {
          setIsSuperAdmin(true);
          setUserId(null);
          setUserRole(user.role);
        }
        else {
          setIsSuperAdmin(false);
          setUserId(user.id);
          setUserRole(user.role);
        }
      }
  }, []);

  const onPromptsSuccess = (resp) => {
    const updatedList = resp.map((item, index) => ({
      ...item,
      key: index + 1,
    }));
    setPrompts(updatedList);
    setOriginalDataList(updatedList)
  };

  const onError = (error) => {
    toast.warning(`Failed to load prompts: ${error}`)
    setShowToast(true);
  };

  const downloadFile = async (fileUrl, filename) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch the file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename || fileUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error while downloading the file:', error);
    }
  };
  const handleListen = (url) => {
    setAudioUrl(url);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setAudioUrl("");
  };


  const actionBodyTemplate = (rowData) => {
    const isDeleted = rowData?.is_deleted === true || Number(rowData?.is_deleted) === 1 || Boolean(rowData?.deleted_at);

    return (

      <div className="d-flex justify-space-between gap-2">
        <button
          className="btn-icons m-1"
          onClick={() => downloadFile(rowData.prompt_url, rowData.prompt_name)}
          style={{ marginLeft: '8px', border: 'none', background: 'none', padding: '0' }}
        >
          <i className="fa fa-download" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
        </button>
        <Button
          label="Listen"
          icon="pi pi-play"
          className="listen"
          id="btnprompt"
          onClick={() => handleListen(rowData.prompt_url)}
        />

         {(isSuperAdmin || loggedInUserACL[MODULE_ACL.VOICE_LIBRARY]?.delete) && !isDeleted && (
          <DeleteIcon handleCallback={() => handlePromptDelete(rowData?.id)} />
         )}



        {/* {(!(selectedData.length > 0) && (isSuperAdmin || moduleOperations['File Deleted']?.delete)) && (
               )}{" "} */}
      </div>
    );
  };

  const handleExport = async () => {
   try {
      // setButtonDisable(true);

      exportToCSV({
         fileName: "voice-files-list",
         data: prompts,
         columns: [
            {
               header: "Name",
               accessor: (row) =>
                  row.prompt_name || "-"
            },
            {
               header: "URL",
               accessor: (row) =>
                  row.prompt_url || "-"
            },
            {
               header: "Duration",
               accessor: (row) =>
                  row.prompt_duration || "-"
            },
            {
               header: "Category",
               accessor: (row) =>
                  row.prompt_category || "-"
            },

            ...(userRole !== USER_ROLES.CALL_CENTRE_ADMIN
               ? [
                  {
                     header: "Deleted By",
                     accessor: (row) =>
                        row.deletedBy?.name || "-"
                  },
                  {
                     header: "Deleted At",
                     accessor: (row) =>
                        row.deleted_at
                           ? new Date(row.deleted_at).toLocaleString(
                              "en-IN",
                              {
                                 day: "2-digit",
                                 month: "short",
                                 year: "numeric",
                                 hour: "2-digit",
                                 minute: "2-digit",
                                 second: "2-digit",
                              }
                           )
                           : "-"
                  }
               ]
               : []),

            {
               header: "Status",
               accessor: (row) => {
                  if (row.prompt_status == 0) return "Pending";
                  if (row.prompt_status == 1) return "Approved";
                  if (row.prompt_status == 2) return "Rejected";
                  return "-";
               }
            }
         ]
      });

   } finally {
      // setButtonDisable(false);
   }
};

  const canRead = hasPermission(
       moduleOperationsForReadPermissionCheck,
       "Voice Library",
       "read",
     );
   
     if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
       return (
         <div
           className="text-center p-4"
           style={{
             marginTop: "50px",
             marginBottom: "50px",
             fontSize: "16px",
           }}
         >
           No read permission found in assigned ACL
         </div>
       );
     }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <div className="card" style={{ marginTop: "20px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title">Voice List</h4>
            <div className="d-flex justify-content-flex-end align-items-start">
              {prompts.length > 0 &&
                        <Button 
                        label="Export Data" 
                        onClick={handleExport} 
                        className="p-button-active p-button-sm" 
                        style={{ marginRight: '10px' }} 
                     >
                     </Button>
                     }

            {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.VOICE_LIBRARY]?.delete) && (
              <Button
                label="Delete Selected"
                onClick={handleMultiDelete}
                className="p-button-danger p-button-sm"
                style={{ marginBottom: '10px', marginLeft: '10px' }}
                disabled={selectedData.length === 0}
              />
            )}
            </div>
          </div>
       <div className="d-flex align-items-center px-3 py-2" style={{ gap: "10px" }}>
          <Form.Group className="mb-0" style={{ width: "300px" }}>
            <Form.Control
              style={{
                height: "40px",
                border: "1px solid #ced4da",
                fontSize: "15px",
              }}
              placeholder="Search by Name..."
              type="text"
              maxLength={100}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              required
            />
          </Form.Group>

          <Button
            label="Refresh"
            icon="pi pi-refresh"
            className="p-button-primary p-button-sm"
            onClick={handleRefresh}
            style={{ height: "40px" }}
          />
        </div>

          <div className="card-body">
            <div className="scroll-container">
              <DataTable
                value={prompts}
                paginator
                rows={10}
                tableStyle={{ minWidth: "50rem" }}
                rowClassName={rowClassName}
              >
                <Column
                  header={<Checkbox
                    checked={selectedData.length === prompts.length && prompts.length > 0}
                    onChange={handleSelectAll}
                  />}
                  headerStyle={{ width: '3rem' }}
                  body={(rowData) => (
                    <Checkbox
                      checked={selectedData.includes(rowData.id)}
                      onChange={() => handleCheckboxToggle(rowData.id)}
                    />
                  )}
                />
                <Column field="prompt_name" header="Name" filterPlaceholder="Search by name" />
                <Column field="prompt_url" header="URL" filterPlaceholder="Search by URL" />
                <Column field="prompt_duration" header="Duration" filterPlaceholder="Search by duration" />
                <Column field="prompt_category" header="Category" filterPlaceholder="Search by category" />


                {userRole !== USER_ROLES.CALL_CENTRE_ADMIN && (
                  <Column field="deletedBy.name" header="Deleted By" filterPlaceholder="Search by category" />
                )}
                {userRole !== USER_ROLES.CALL_CENTRE_ADMIN && (
                  <Column field="deleted_at" header="Deleted At" filterPlaceholder="Search by category"
                    body={(rowData) =>
                      new Date(rowData.deleted_at).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })
                    }

                  />
                )}
                <Column
                  header="Status"
                  body={(rowData) => {
                    let statusText = '';
                    if (rowData.prompt_status == 0) {
                      statusText = 'Pending';
                    } else if (rowData.prompt_status == 1) {
                      statusText = 'Approved';
                    } else if (rowData.prompt_status == 2) {
                      statusText = 'Rejected';
                    }

                    return <span className="status-text">{statusText}</span>;
                  }}
                  style={{ textAlign: 'center' }}
                />

                <Column
                  header="Actions"
                  body={actionBodyTemplate}
                  style={{ textAlign: "center", width: "12rem" }}
                />
              </DataTable>
            </div>
          </div>
        </div>

        <RenderDeleteModal
          show={enableDeleteModal}
          setShow={setEnableDeleteModal}
          setConfirmDelete={setConfirmDelete}
          isMultiDelete={isMultiDelete}
          clearSelectedData={() => setSelectedPrompt([])}
        />

{/* 
        <ToastNotification
          show_toast={showToast}
          set_show_toast={setShowToast}
          {...toastProps}
        /> */}
      </div>
      <Dialog
        header="Audio Playback"
        visible={isModalVisible}
        style={{
          width: "40vw",
          position: "absolute",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
        onHide={handleModalClose}
      >
        <audio controls style={{ width: "100%" }}>
          <source src={audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </Dialog>
    </>
  );
};

export default ViewVoiceFiles;
